<template>
  <div
    :class="{ 'shape-arrowhead--reverse': isReverse }"
    class="shape-arrowhead">
    <div class="shape-arrowhead__body">
      <div class="shape-arrowhead__icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArrowheadIcon',

  props: {
    isReverse: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../scss/shapes/arrowhead";
</style>
